export default function trackDownloadGA(id, resource_type) {
  gtag('event', 'file_download', {
    resource_id: id,
    resource_type: resource_type
  })
}

window.trackDownloadGA = trackDownloadGA